import { CountUp } from 'countup.js';

import '../sass/number-charts.scss';

(() => {
    const $blocks = document.querySelectorAll('.number-charts');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $content = $block.querySelector('.number-charts__content');
        const $charts = $block.querySelectorAll('.number-charts__statistic-chart');

        if (!$content || !$charts.length) return;

        const animateCharts = () => {
            $charts.forEach($chart => {
                if ($chart.dataset.numberChartsAnimated === 'true') return;

                const $value = $chart.querySelector('.number-charts__statistic-value');
                const countUpValue = parseInt($value?.dataset?.countUpValue, 10);

                $chart.dataset.numberChartsAnimated = 'true';
                $chart.classList.add('is-animated');

                if (!$value || Number.isNaN(countUpValue)) return;

                const counter = new CountUp($value, countUpValue, {
                    duration: 1.5,
                    prefix: $value.dataset.countUpPrefix || '',
                    suffix: $value.dataset.countUpSuffix || '',
                });

                if (!counter.error) counter.start();
            });
        };

        $content.addEventListener('onScreen', animateCharts);

        if ($content.classList.contains('is-on-screen')) {
            animateCharts();
        }
    });
})();
